export async function copyToClipboard(textPromise: Promise<string>): Promise<void> {
    // Check if ClipboardItem is not supported, or if it's Firefox
    // Use the simpler writeText API for better compatibility
    if (!window.ClipboardItem || navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        return navigator.clipboard.writeText(await textPromise);
    }

    // Use ClipboardItem for browsers that support it
    return new Promise((resolve, reject) => {
        return navigator.clipboard
            .write([
                new ClipboardItem({
                    'text/plain': new Promise((resolveBlob, rejectBlob) => {
                        textPromise
                            .then((text) => resolveBlob(new Blob([text], { type: 'text/plain' })))
                            .catch((error) => {
                                reject(error);
                                rejectBlob();
                            });
                    }),
                }),
            ])
            .then(resolve)
            .catch(reject);
    });
}
